const appName = 'calibration'
const environment = window.config ? window.config.environment : 'local'

async function hash(key) {
  const encoder = new TextEncoder()
  const data = encoder.encode(`${appName}/${environment}/${key}`)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(digest))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

export default {
  // Session storage is cleared when the browser tab is closed and is Isolated per tab.
  // Local storage persists across browser sessions and is shared across all tabs.
  session: {
    async setItem(key, value) {
      const hashedKey = await hash(key)
      sessionStorage.setItem(hashedKey, value)
    },
    async getItem(key) {
      const hashedKey = await hash(key)
      return sessionStorage.getItem(hashedKey)
    },
    clear() {
      console.log('DEBUG => [storage] Clearing session storage...')
      sessionStorage.clear()
    }
  },
  local: {
    async setItem(key, value) {
      const hashedKey = await hash(key)
      localStorage.setItem(hashedKey, value)
    },
    async getItem(key) {
      const hashedKey = await hash(key)
      return localStorage.getItem(hashedKey)
    },
    clear() {
      console.log('DEBUG => [storage] Clearing local storage...')
      localStorage.clear()
    }
  }
}
